/** An editable visitor row (Besuch). The id is local — for stable list keys. */
export interface VisitorRow {
    id: string;
    name: string;
    position: string;
    /** What the visit was about — a note, often a whole paragraph. */
    note: string;
}

/**
 * A row that says something but does not say WHO. An entirely empty row is not
 * an error — it is a row somebody added and left, and the save drops it — but a
 * function or a note with no name is a visit nobody can be identified from.
 */
export function visitorNeedsName(row: VisitorRow): boolean {
    return (
        row.name.trim() === '' &&
        (row.position.trim() !== '' || row.note.trim() !== '')
    );
}

/** The rows that block a save, in the order they appear. */
export function namelessVisitors(rows: VisitorRow[]): VisitorRow[] {
    return rows.filter(visitorNeedsName);
}
